/** 门店对外展示栏目；只有已接入的栏目显示内容编辑入口。 */
export interface StudioDisplaySection {
  key: string;
  name: string;
  title: string;
  icon: string;
  description: string;
  editable?: boolean;
  /** 隐藏侧栏和概览入口，旧地址返回展示概览。 */
  hidden?: boolean;
  /** 保留栏目位置，暂不开放点击入口；清除此项即可恢复。 */
  disabledReason?: string;
  relatedRoutes?: string[];
  features: { title: string; description: string }[];
}

export const STUDIO_DISPLAY_SECTIONS: StudioDisplaySection[] = [
  {
    key: 'Brand', name: 'StudioDisplayBrand', title: '品牌故事', icon: 'ri-book-open-line', editable: true,
    description: '用图片和文字介绍影楼品牌、门店环境与服务理念。',
    features: [
      { title: '品牌图片', description: '展示门店形象、环境和品牌故事配图。' },
      { title: '内容介绍', description: '介绍影楼的发展故事、服务理念与特色。' },
    ],
  },
  {
    key: 'Styles', name: 'StudioDisplayStyles', title: '风格案例', icon: 'ri-gallery-line', editable: true,
    relatedRoutes: ['StudioDisplayStyleCategory', 'StudioDisplayStyleAlbum'],
    description: '按三级结构组织案例图片，供客户挑选风格并分享参考。',
    features: [
      { title: '三级图片展示', description: '按分类、案例、图片详情组织风格内容。' },
      { title: '客户备选', description: '让客户保留心仪案例，作为沟通拍摄风格的参考。' },
      { title: '小程序分享', description: '将备选案例分享给朋友，一起参考拍摄风格。' },
    ],
  },
  {
    key: 'Photos', name: 'StudioDisplayPhotos', title: '最新客片', icon: 'ri-camera-line', editable: true,
    relatedRoutes: ['StudioDisplayPhotoCategory', 'StudioDisplayPhotoAlbum'],
    description: '按三级结构展示最新客片，呈现门店的真实拍摄作品。',
    features: [
      { title: '三级图片展示', description: '按分类、客片相册、图片详情组织内容。' },
      { title: '最新作品', description: '挑选适合对外展示的客片，更新门店作品内容。' },
    ],
  },
  {
    key: 'Packages', name: 'StudioDisplayPackages', title: '套餐价格', icon: 'ri-price-tag-3-line', editable: true,
    relatedRoutes: ['Package'],
    description: '与客户管理共用本店套餐，统一维护图片、内容、原价与优惠价。',
    features: [
      { title: '套餐展示', description: '用图片介绍套餐内容，并展示对应价格。' },
      { title: '统一套餐价格', description: '客户管理与门店展示使用同一套餐资料，修改一次，两处共用。' },
      { title: '直接下单', description: '客户从展示套餐进入下单，衔接影楼订单流程。' },
    ],
  },
  {
    key: 'Products', name: 'StudioDisplayProducts', title: '产品展示', editable: true, icon: 'ri-box-3-line',
    description: '组织合作工厂的产品，设置面向客户的展示价格。',
    features: [
      { title: '工厂产品展示', description: '使用合作工厂提供的产品图片与资料。' },
      { title: '展示价格', description: '支持修改或隐藏对客展示价格。' },
      { title: '多工厂展示', description: '在同一门店展示页中展示多家合作工厂的产品。' },
    ],
  },
  {
    key: 'Team', name: 'StudioDisplayTeam', title: '技术团队', icon: 'ri-team-line',
    hidden: true,
    description: '通过人物图片与内容介绍，展示摄影、化妆等技术团队。',
    features: [
      { title: '团队图片', description: '展示技术团队成员的形象与作品。' },
      { title: '人员介绍', description: '介绍成员的岗位、专长与服务风格。' },
    ],
  },
  {
    key: 'Promotion', name: 'StudioDisplayPromotion', title: '销售推广', icon: 'ri-megaphone-line',
    disabledReason: '暂未开放',
    description: '围绕门店展示页组织分销、拼团与限时秒杀活动。',
    features: [
      { title: '分销系统', description: '创建邀请码，关联推广邀请关系。' },
      { title: '拼团', description: '通过拼团活动推广门店套餐与产品。' },
      { title: '限时秒杀', description: '设置限时活动，展示活动套餐与优惠。' },
    ],
  },
];
